import { useCallback } from "react";
import { ProfileTypes } from "src/api/types";

export const useIdentityEvent = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return useCallback(
    async (
      patientInfo: Pick<ProfileTypes, "id" | "email"> & Partial<ProfileTypes>,
      sms_marketing_decision = true
    ) => {
      if (!window.freshpaint) return;

      if (patientInfo.id) {
        if (patientInfo.email) {
          freshpaint.alias(patientInfo.email, patientInfo.id);
        }
        freshpaint.identify(patientInfo.id, {
          first_name: patientInfo.first_name,
          last_name: patientInfo.last_name,
          email: patientInfo.email,
          phone: patientInfo.phone_number,
          timezone: timezone,
          cio_subscription_preferences: {
            topics: {
              topic_1: sms_marketing_decision,
            },
          },
        });
      }
    },
    [timezone]
  );
};
